export default "__VITE_ASSET__51fcb164__"